/**
 * Brazilian Portuguese strings for the `streamers` namespace — the live vitrine page.
 *
 * Keys are in English (repo convention); values are the pt-BR copy shown to users.
 */
export const streamers = {
  title: 'Streamers BR',
  intro: 'Quem está transmitindo Gielinor em português, agora — as maiores audiências primeiro.',
  listLabel: 'Transmissões ao vivo',
  loading: 'Sondando as transmissões…',
  error: 'A Twitch não respondeu. Tente de novo em instantes.',
  retry: 'Tentar de novo',
  empty: 'Ninguém ao vivo em português agora. Volte mais tarde — ou seja você a primeira live.',
  liveBadge: 'Ao vivo',
  viewers_one: '{{count, number}} espectador',
  viewers_many: '{{count, number}} espectadores',
  viewers_other: '{{count, number}} espectadores',
  ctaTitle: 'Faz live de RuneScape em português?',
  ctaText:
    'A vitrine cresce com a comunidade: além das lives da categoria, vamos manter uma lista curada de canais parceiros. Chama a gente e entre para ela.',
  ctaButton: 'Quero aparecer aqui',
}
